import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import he from './he.json';
import en from './en.json';
import ru from './ru.json';

export type SupportedLanguage = 'he' | 'en' | 'ru';

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['he', 'en', 'ru'];

export const RTL_LANGUAGES = new Set<SupportedLanguage>(['he']);

const STORAGE_KEY = 'hash_language';

function readPersistedLanguage(): SupportedLanguage {
  const stored = localStorage.getItem(STORAGE_KEY) as SupportedLanguage | null;
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;
  return 'he';
}

i18n.use(initReactI18next).init({
  resources: {
    he: { translation: he },
    en: { translation: en },
    ru: { translation: ru },
  },
  lng: readPersistedLanguage(),
  fallbackLng: 'he',
  interpolation: {
    escapeValue: false,
  },
});

// Keep <html dir> + <html lang> in sync with the active language so MUI's RTL
// pipeline and screen readers both pick it up automatically.
function applyDocumentDir(lang: SupportedLanguage) {
  document.documentElement.lang = lang;
  document.documentElement.dir = RTL_LANGUAGES.has(lang) ? 'rtl' : 'ltr';
}

applyDocumentDir(i18n.language as SupportedLanguage);

export function setLanguage(lang: SupportedLanguage) {
  void i18n.changeLanguage(lang);
  localStorage.setItem(STORAGE_KEY, lang);
  applyDocumentDir(lang);
}

export default i18n;
